const BARS = Array.from({ length: 48 }, (_, i) => 30 + Math.abs(Math.sin(i * 1.7) * 55 + Math.cos(i * 0.6) * 15));

export const fmt = (s) => (isFinite(s) && s > 0 ? `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}` : "0:00");

export const Waveform = ({ pct, active, onSeek, testId, bars = 48 }) => (
  <div data-testid={testId} className="relative flex-1 h-8 flex items-center gap-[2px] cursor-pointer"
    onClick={(e) => { const r = e.currentTarget.getBoundingClientRect(); onSeek((e.clientX - r.left) / r.width); }}>
    {BARS.slice(0, bars).map((h, i) => (
      <span key={i} style={{ height: `${h}%` }}
        className={`flex-1 rounded-full transition-colors ${(i / bars) * 100 < pct ? "bg-[#D90429]" : "bg-white/15"} ${active ? "animate-pulse" : ""}`} />
    ))}
  </div>
);
